import { BehaviorSubject, catchError, map, Observable, switchMap } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import {
  CertAuthClientService,
  NIASBizAPIDtosAuthResponseDto,
  NIASBizAPIDtosUserDataDto,
  SessionApiClientService,
} from '../api/v1';
import { Router } from '@angular/router';
import { ReferentHomeRoute } from '../constants/routes.constant';

@Injectable({
  providedIn: 'root',
})
export class CertAuthService {
  private router: Router = inject(Router);
  private certAuthClientService: CertAuthClientService = inject(CertAuthClientService);
  private sessionApiClientService: SessionApiClientService = inject(SessionApiClientService);

  private user: BehaviorSubject<NIASBizAPIDtosUserDataDto | null> =
    new BehaviorSubject<NIASBizAPIDtosUserDataDto | null>(null);

  public isAuthenticate$: Observable<boolean> = this.user.pipe(map((x) => x != null));

  public get isAuthenticate(): boolean {
    return this.user.getValue() != null;
  }

  public get userValue(): NIASBizAPIDtosUserDataDto | null {
    return this.user.getValue();
  }

  public saveUser(user: NIASBizAPIDtosUserDataDto) {
    this.user.next(user);
  }

  public getSession() {
    return this.sessionApiClientService.sessionApiGet().pipe(
      map((res) => {
        if (res) {
          this.user.next(res);
        } else {
          this.clearUserAndRedirect();
        }
      })
    );
  }

  public loginWithCert() {
    return this.certAuthClientService.certAuthCertificate().pipe(
      switchMap((res: NIASBizAPIDtosAuthResponseDto) => {
        this.user.next(res.User_data!);
        return this.sessionApiClientService.sessionApiGet().pipe(
          map((userDataDTO: NIASBizAPIDtosUserDataDto) => {
            this.user.next(userDataDTO);
            return true;
          })
        );
      })
    );
  }

  public logout(skipRequest = false) {
    if (skipRequest) {
      this.clearUserAndRedirect();
      return;
    }

    this.sessionApiClientService.sessionApiLogout().subscribe({
      next: (res) => {
        this.clearUserAndRedirect();
      },
    });
  }

  private clearUserAndRedirect() {
    this.user.next(null);
    this.router.navigate([ReferentHomeRoute]);
  }
}
